module.exports = __webpack_public_path__ + "static/media/app-bar-login.e95886d8.svg";